<template>
  <v-container id="vendor-edit" fluid tag="section">
    <v-row>
      <v-col cols="12" md="12">
        <v-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{ $i18n.t("My Account") }}
            </div>
          </template>

          <v-alert dense outlined type="error" v-if="showNotice">
            {{
              $i18n.t(
                "Your account is blocked due to non-payment of your invoice."
              )
            }}
            {{ $i18n.t("Please make the payment to resume services.") }}
          </v-alert>

          <keep-alive>
            <v-tabs v-model="tab" class="elevation-2" icons-and-text>
              <v-tab
                v-for="(t, i) in tabs"
                :key="i"
                :href="`#tab-${i}`"
                @click="tabChanged(t.name)"
              >
                {{ t.name }}
                <v-icon>{{ t.icon }}</v-icon>
              </v-tab>

              <v-tab-item v-for="(t, i) in tabs" :key="i" :value="'tab-' + i">
                <v-card flat tile v-if="t.name == 'Invoices'">
                  <v-card-text class="mt-10">
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th class="primary--text">
                            {{ $i18n.t("Invoice #") }}
                          </th>
                          <th class="primary--text">
                            {{ $i18n.t("Date Created") }}
                          </th>
                          <th class="primary--text">
                            {{ $i18n.t("For Month") }}
                          </th>
                          <th class="primary--text">
                            {{ $i18n.t("Due Date") }}
                          </th>
                          <th class="primary--text">{{ $i18n.t("Amount") }}</th>
                          <th class="primary--text">
                            {{ $i18n.t("TDS Deduction") }}
                          </th>
                          <th class="primary--text">
                            {{ $i18n.t("Payable") }}
                          </th>
                          <th class="primary--text">{{ $i18n.t("Status") }}</th>
                          <th class="primary--text">{{ $i18n.t("Action") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="invoice in recentInvoices"
                          :key="invoice._id + 'account_inv'"
                        >
                          <td>{{ invoice.invoiceNo }}</td>
                          <td>{{ invoice.invoiceDateStr }}</td>
                          <td>
                            {{ integerToMonth(invoice.fromDate) }}
                            <!-- -
                            {{ integerToDate(invoice.toDate) }} -->
                          </td>
                          <td>{{ integerToDate(invoice.dueDate) }}</td>
                          <td>
                            {{ invoice.fare.currency }} {{ invoice.fare.total }}
                          </td>
                          <td>
                            <v-row v-if="invoice.status != 3">
                              <v-col cols="12" sm="7" md="7" lg="7">
                                <v-select
                                  style="width:170px"
                                  :label="$i18n.t('TDS Deduction')"
                                  :items="[
                                    { name: '8%', value: 8 },
                                    { name: '9%', value: 9 },
                                    { name: '10%', value: 10 },
                                    { name: '11%', value: 11 },
                                  ]"
                                  item-text="name"
                                  item-value="value"
                                  v-model="invoice.tds.tdsPercent"
                                  clearable
                                />
                              </v-col>
                              <v-col
                                cols="12"
                                sm="3"
                                md="3"
                                lg="3"
                                style="align-self: center"
                              >
                                <v-btn
                                  x-small
                                  :title="$i18n.t('Apply TDS ')"
                                  small
                                  color="blue"
                                  :loading="invoice.isLoading"
                                  @click="saveTDSdeduction(invoice)"
                                >
                                  {{ $i18n.t("Apply TDS ") }}
                                </v-btn>
                              </v-col>
                            </v-row>
                            {{
                              invoice.status == 3 &&
                              invoice.tds != null &&
                              (invoice.tds.tdsPercent || invoice.tds.tdsAmount)
                                ? invoice.tds.tdsPercent +
                                  "% | " +
                                  invoice.tds.tdsAmount
                                : ""
                            }}
                          </td>
                          <td>{{ payableAmopunt(invoice) }}</td>
                          <td>
                            <v-chip class="ma-2" v-if="invoice.status == 3">
                              {{ invoice.invoiceStatus }}
                            </v-chip>
                            <v-btn
                              v-show="invoice.status != 3"
                              class="green-md"
                              target="_blank"
                              text
                              small
                              style="
                                background-color: #72c02c;
                                font-size: 18px;
                                border-radius: 7px;
                                color: white;
                                text-align: center;
                                width: 100px;
                              "
                              :href="
                                '/api/payment/trans/create/invoice?inv_id=' +
                                invoice._id
                              "
                            >
                              Pay Now
                            </v-btn>
                          </td>
                          <td>
                            <v-btn
                              text
                              fab
                              x-small
                              :title="$i18n.t('Print Invoice')"
                              small
                              color="primary"
                              @click="downloadInv(invoice)"
                            >
                              <v-icon>mdi-printer</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>

                <v-card flat tile v-if="t.name == 'Payments'">
                  <v-card-text class="mt-10">
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th class="primary--text">
                            {{ $i18n.t("Date Created") }}
                          </th>
                          <th class="primary--text">
                            {{ $i18n.t("Amount") }}
                          </th>
                          <th class="primary--text">
                            {{ $i18n.t("Status") }}
                          </th>
                          <th class="primary--text">
                            {{ $i18n.t("Payment Mode") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="pt in recentPayments"
                          :key="pt._id + 'account_pt'"
                        >
                          <td>
                            {{ pt.createdAt | moment("DD MMM YYYY hh:mm a") }}
                          </td>
                          <td>{{ pt.currency }} {{ pt.amount }}</td>
                          <td>{{ pt.statusStr }}</td>
                          <td>
                            {{
                              pt.paytmDetail != null ? pt.paytmDetail.mode : ""
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>

                <v-card flat tile v-if="t.name == 'Subscription Plan'">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="primary--text">
                          {{ $i18n.t("Country") }}
                        </th>
                        <th class="primary--text">
                          {{ $i18n.t("Currency") }}
                        </th>
                        <th class="primary--text">
                          {{ $i18n.t("Min Rental") }}
                        </th>
                        <th class="primary--text">
                          {{ $i18n.t("Subsidy") }}
                        </th>
                        <th class="primary--text">
                          {{ $i18n.t("Per Trip Cost") }}
                        </th>
                        <th class="primary--text">
                          {{ $i18n.t("Expiry Date") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(plan, index) in mySubscriptionPlan.plans"
                        :key="plan._id + index + 'account_pt'"
                      >
                        <td>{{ plan.country }}</td>
                        <td>{{ plan.currency }}</td>
                        <td>{{ plan.minRental }}</td>
                        <td>{{ plan.subsidy }}</td>
                        <td>{{ plan.perTripCost }}</td>
                        <td>{{ integerToDate(plan.expiry) }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </keep-alive>
        </v-card>
      </v-col>
    </v-row>

    <z-invoice-download
      :payload="payload"
      :showDialog="showInvoiceDoanload"
      @closeDialog="closeDialog"
      :isMail="isMail"
      :invoice="invForMail"
    ></z-invoice-download>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost, doPostWithDownload } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import EntityRow from "@/views/entity/EntityRow.vue";
import EntityEdit from "@/views/entity/EntityEdit.vue";

@Component({
  components: {
    EntityRow,
    EntityEdit,
  },
  props: {
    singlePage: {
      default: false,
    },
    vendor_id: {
      default: null,
    },
  },
})
export default class VendorEdit extends Vue {
  tab = null;
  noticeData = null;
  recentInvoices = [];
  recentPayments = [];
  mySubscriptionPlan = { plans: [] };
  showRecentInvoicesFilter = null;
  showRecentPaymentsFilter = null;
  showInvoiceDoanload = false;
  payload = {};
  isMail = false;
  invForMail = null;
  hideFilter = null;
  showNotice = null;
  tabs = [
    { name: "Invoices", icon: "mdi-map-marker-path" },
    // { name: "Payments", icon: "mdi-card-text-outline" },
    // { name: "Subscription Plan", icon: "mdi-domain" },
  ];
  recentInvoicesURL = "/api/invoice/corp/subscription/grid?_search=true";
  filter_recentInvoicesURL = "/api/invoice/corp/subscription/grid?_search=true";
  invoiceFilter = {
    year: null,
    invoice_no: null,
    startDate: null,
    endDate: null,
  };
  recentInvoices_page = 1;
  recentInvoices_total = 0;
  recentInvoices_records = 0;
  recentInvoices_size = 30;

  recentPaymentsURL = "/api/payment/trans/corp/subscription?_search=true";
  filter_recentPaymentsURL =
    "/api/payment/trans/corp/subscription?_search=true";
  paymentFilter = { year: null, startDate: null, endDate: null };
  recentPayments_page = 1;
  recentPayments_total = 0;
  recentPayments_records = 0;
  recentPayments_size = 30;

  setFilter() {
    const dt = new Date();
    const currentYear = dt.getFullYear();
    if (dt.getMonth() > 2) {
      this.invoiceFilter.year = currentYear * 10000 + 401;
      this.paymentFilter.year = currentYear * 10000 + 401;
    } else {
      this.invoiceFilter.year = (currentYear - 1) * 10000 + 401;
      this.paymentFilter.year = (currentYear - 1) * 10000 + 401;
    }
  }

  closeDialog() {
    this.showInvoiceDoanload = false;
    this.payload = {};
    this.invForMail = null;
    this.isMail = false;
  }

  invEmail(_invoice) {
    this.invForMail = _invoice;
    this.isMail = true;
    this.showInvoiceDoanload = true;
  }

  filterRecentPayments() {
    let url = this.recentPaymentsURL;

    if (this.paymentFilter.startDate) {
      url = url + "&fromDate=" + this.paymentFilter.startDate;
    }
    if (this.paymentFilter.endDate) {
      url = url + "&toDate=" + this.paymentFilter.endDate;
    }
    if (this.paymentFilter.status) {
      url = url + "&status=" + this.paymentFilter.status;
    }

    url = url + "&sord=desc&sidx=_id";

    this.fetchRecentPayments(url, 1);
    this.filter_recentPaymentsURL = url;
  }

  async fetchRecentPayments(_url, _page) {
    if (!_url) {
      _url = this.recentPaymentsURL;
    }
    if (!_page) {
      _page = 1;
    }

    _url = _url + "&page=" + _page + "&size=" + this.recentPayments_size;

    const inv_ids = [];
    for (let i = 0; i < this.recentInvoices.length; i++) {
      inv_ids.push(this.recentInvoices[i]._id);
    }

    try {
      const response = await doPost(_url, inv_ids);
      this.recentPayments = response.rows;
      this.recentPayments_page = response.page;
      this.recentPayments_total = response.total;
      this.recentPayments_records = response.records;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async fetchRecentInvoices(_url, _page) {
    if (!_url) {
      _url = this.recentInvoicesURL;
    }
    if (!_page) {
      _page = 1;
    }

    _url = _url + "&page=" + _page + "&size=" + this.recentInvoices_size;

    try {
      const response = await doGet(_url);
      for (let index = 0; index < response.rows.length; index++) {
        response.isLoading = null;
        if (response.rows[index] != null && !response.rows[index].tds)
          response.rows[index].tds = { tdsPercent: "", tdsAmount: "" };
      }
      this.recentInvoices = response.rows;
      this.recentInvoices_page = response.page;
      this.recentInvoices_total = response.total;
      this.recentInvoices_records = response.records;

      this.fetchMessage();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  integerToDate(date) {
    if (date != null && date != undefined) {
      date = date.toString();
      if (date.indexOf("-") == -1) {
        date =
          date.substring(0, 4) +
          "-" +
          date.substring(4, 6) +
          "-" +
          date.substring(6, 8);
      }
    }
    return date;
  }

  integerToMonth(date) {
    if (date != null && date != undefined) {
      date = date.toString();
      if (date.indexOf("-") == -1) {
        date = date.substring(0, 4) + "-" + date.substring(4, 6);
      }
    }
    return date;
  }

  async fetchMessage() {
    this.noticeData = "";
    let today = null;
    const dt = new Date();
    const y = dt.getFullYear();
    let m = dt.getMonth() + 1;
    if (m < 10) {
      m = "0" + m;
    }
    let d = dt.getDate();
    if (d < 10) {
      d = "0" + d;
    }
    today = parseInt(y + "" + m + "" + d);
    if (this.recentInvoices && this.recentInvoices.length > 0) {
      for (let i = 0; i < this.recentInvoices.length; i++) {
        if (
          this.recentInvoices[i] &&
          this.recentInvoices[i].status != 3 &&
          this.recentInvoices[i].dueDate < today
        ) {
          this.showNotice = true;
          this.noticeData = this.$i18n.t(
            "Your account is blocked due to non-payment of your invoice. Please make the payment to resume services."
          );
          break;
        }
      }
    }
  }

  tabChanged(_for) {
    if (_for == "Invoices") {
      this.filterRecentInvoices();
      this.showFilterOptions("recentInvoices");
    } else if (_for == "Payments") {
      this.filterRecentPayments();
      this.showFilterOptions("recentPayments");
    } else if (_for == "Subscription Plan") {
      this.getMySubscriptionPlan();
      this.showFilterOptions("subscriptionPlan");
    }
  }

  filterRecentInvoices() {
    let url = this.recentInvoicesURL;

    if (this.invoiceFilter.startDate) {
      url = url + "&fromDate=" + this.invoiceFilter.startDate;
    }
    if (this.invoiceFilter.endDate) {
      url = url + "&toDate=" + this.invoiceFilter.endDate;
    }
    if (this.invoiceFilter.invoice_no) {
      url = url + "&invoiceNo=" + this.invoiceFilter.invoice_no;
    }
    if (this.invoiceFilter.year != null && !isNaN(this.invoiceFilter.year)) {
      url = url + "&financialYear=" + this.invoiceFilter.year;
    }

    this.fetchRecentInvoices(url, 1);
    this.filter_recentInvoicesURL = url;
  }

  refreshRecentInvoices() {
    this.invoiceFilter = {};
    this.invoiceFilter.from_date = null;
    this.invoiceFilter.to_date = null;
    const dt = new Date();
    const currentYear = dt.getFullYear();
    if (dt.getMonth() > 2) {
      this.invoiceFilter.year = currentYear * 10000 + 401;
    } else {
      this.invoiceFilter.year = (currentYear - 1) * 10000 + 401;
    }

    this.filter_recentInvoicesURL = this.recentInvoicesURL;
    this.filterRecentInvoices();
  }

  async getMySubscriptionPlan() {
    if (
      this.mySubscriptionPlan &&
      this.mySubscriptionPlan.plans &&
      this.mySubscriptionPlan.plans.length > 0
    ) {
      return;
    }
    try {
      this.mySubscriptionPlan = await doGet("/api/corp/subscription/get/plans");
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  showFilterOptions(_for) {
    if (_for == "recentInvoices") {
      this.showRecentInvoicesFilter = true;
      this.showRecentPaymentsFilter = null;
      this.hideFilter = null;
    } else if (_for == "Payments") {
      this.showRecentInvoicesFilter = null;
      this.showRecentPaymentsFilter = true;
      this.hideFilter = null;
    } else if (_for == "subscriptionPlan") {
      this.showRecentInvoicesFilter = null;
      this.showRecentPaymentsFilter = null;
      this.hideFilter = true;
    }
  }

  async downloadInv(_invoice) {
    try {
      await doPostWithDownload("/api/invoice/bulk/invoices/print2", {
        printType: 999,
        invoice_ids: _invoice._id,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async deductTDS(_invoice) {
    try {
      await doPostWithDownload("/api/invoice/bulk/invoices/print2", {
        printType: 999,
        invoice_ids: _invoice._id,
      });
    } catch (e) {
      console.log(e);
    }
  }

  invDownload(_invoice) {
    let ids = "";
    const clients = [];
    let vendor_id, client_id, vendorEntity_id, clientEntity_id;
    let v_consider = true;
    let c_consider = true;
    let vEntity_consider = true;
    let cEntity_consider = true;
    if (_invoice) {
      ids += _invoice._id;
      clients.push(_invoice.client_id);
      vendor_id = _invoice.vendor_id;
      client_id = _invoice.client_id;
      vendorEntity_id = _invoice.vendorEntity._id;
      clientEntity_id = _invoice.clientEntity._id;
    } else {
      this.grid.rows.forEach(function (t) {
        if (t.selected) {
          ids += t._id + ",";
          clients.push(t.client_id);
          if (v_consider) {
            if (vendor_id == null) {
              vendor_id = t.vendor_id;
            } else if (vendor_id != t.vendor_id) {
              v_consider = false;
            }
          }
          if (c_consider) {
            if (client_id == null) {
              client_id = t.client_id;
            } else if (client_id != t.client_id) {
              c_consider = false;
            }
          }
          if (vEntity_consider) {
            if (vendorEntity_id == null) {
              vendorEntity_id = t.vendorEntity._id;
            } else if (vendorEntity_id != t.vendorEntity._id) {
              vEntity_consider = false;
            }
          }
          if (cEntity_consider) {
            if (clientEntity_id == null) {
              clientEntity_id = t.clientEntity._id;
            } else if (clientEntity_id != t.clientEntity._id) {
              cEntity_consider = false;
            }
          }
        }
      });
    }

    if (!ids) {
      common.setError("Please select invoice(s) to download PDF/Excel");
      return false;
    }

    const payload = { invoice_ids: ids, client_ids: clients };
    if (v_consider) {
      payload.vendor_id = vendor_id;
    }
    if (c_consider) {
      payload.client_id = client_id;
    }
    if (vEntity_consider) {
      payload.vendorEntity_id = vendorEntity_id;
    }
    if (cEntity_consider) {
      payload.clientEntity_id = clientEntity_id;
    }
    this.payload = payload;
    this.showInvoiceDoanload = true;
  }

  async saveTDSdeduction(invoice) {
    if (invoice != null && invoice.tds != null) {
      invoice.isLoading = true;
      await doPost(
        "/api/invoice/" + invoice._id + "/corp/subscription/tdsdeduct",
        {
          tdsPercent: invoice.tds.tdsPercent,
        }
      );
      common.showMessage(this.$i18n.t("TDS Applied"));
      invoice.isLoading = null;
      this.filterRecentInvoices();
    } else {
      common.setError(this.$i18n.t("Invoice Not Selected"));
    }
  }

  payableAmopunt(invoice) {
    if (invoice != null) {
      if (
        invoice.fare.amountPaid != null &&
        invoice.tds != null &&
        invoice.tds.tdsAmount != null
      ) {
        return Math.round(
          invoice.fare.total - invoice.fare.amountPaid - invoice.tds.tdsAmount
        );
      } else if (invoice.fare.amountPaid != null) {
        return Math.round(invoice.fare.total - invoice.fare.amountPaid);
      } else {
        return Math.round(invoice.fare.total);
      }
    }
  }

  async mounted() {
    // this.setFilter();
    this.showFilterOptions("recentInvoices");
    this.filterRecentInvoices();
  }
  get loading() {
    return common.loading;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.client-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  /* left: 10px; */
  right: 10px;
  font-size: 12px;
}
.absolute-client-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  position: absolute;
  right: 10px;
  font-size: 9px;
}
</style>
